var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91579 8.26316C4.48026 8.26316 4.95789 8.74079 4.95789 9.30526V9.65263L6.52105 8.48026C6.69474 8.35 6.91184 8.26316 7.15066 8.26316H10.1684C10.3421 8.26316 10.5158 8.11118 10.5158 7.91579V1.66316C10.5158 1.48947 10.3421 1.31579 10.1684 1.31579H1.83158C1.63618 1.31579 1.48421 1.48947 1.48421 1.66316V7.91579C1.48421 8.11118 1.63618 8.26316 1.83158 8.26316H3.91579ZM4.95789 10.9553L4.93618 10.977L4.82763 11.0421L4.45855 11.3243C4.35 11.4112 4.21974 11.4112 4.08947 11.3678C3.98092 11.3026 3.91579 11.1941 3.91579 11.0421V10.5862V10.4559V10.4342V10.3474V9.30526H2.87368H1.83158C1.05 9.30526 0.442105 8.69737 0.442105 7.91579V1.66316C0.442105 0.903289 1.05 0.273683 1.83158 0.273683H10.1684C10.9283 0.273683 11.5579 0.903289 11.5579 1.66316V7.91579C11.5579 8.69737 10.9283 9.30526 10.1684 9.30526H7.15066L4.95789 10.9553Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.579e6b34a5407ee1780b268dabd512ec.svg";
export { ForwardRef as ReactComponent };